import httpClient from '../../../api/httpClient';
import API_CONFIG from '../../../config/api.config';
import { TransactionReportResponse, TransactionReportFilterParams } from '../types/transaction-report.types';

class TransactionReportApi {
  private baseURL = `${API_CONFIG.BASE_URL}/credit-debit-tracker`;

  async getTransactionReport(params: TransactionReportFilterParams): Promise<TransactionReportResponse> {
    const searchParams = new URLSearchParams();
    
    if (params.fromDate) searchParams.append('fromDate', params.fromDate);
    if (params.toDate) searchParams.append('toDate', params.toDate);
    if (params.type) searchParams.append('type', params.type);
    if (params.chartOfAccountId) searchParams.append('chartOfAccountId', params.chartOfAccountId);
    if (params.location) searchParams.append('location', params.location);

    const response = await httpClient.get(`/credit-debit-tracker/report?${searchParams.toString()}`);
    return response.data;
  }

  async exportTransactionReportCSV(params: TransactionReportFilterParams): Promise<Blob> {
    const searchParams = new URLSearchParams();
    
    if (params.fromDate) searchParams.append('fromDate', params.fromDate);
    if (params.toDate) searchParams.append('toDate', params.toDate);
    if (params.type) searchParams.append('type', params.type);
    if (params.chartOfAccountId) searchParams.append('chartOfAccountId', params.chartOfAccountId);
    if (params.location) searchParams.append('location', params.location);

    const response = await httpClient.get(`/credit-debit-tracker/report/export?${searchParams.toString()}`, {
      responseType: 'blob'
    });
    return response.data;
  }
}

export const transactionReportApi = new TransactionReportApi();
